<template>
  <div
    class="dx-field flex-column"
    :class="marginBottom ? 'mb-4' : 'mb-0'"
  >
    <div class="d-flex justify-content-between align-self-start w-100">
      <div class="dx-field-label flex-grow-1">
        {{ label }}
      </div>
      <router-link
        v-if="link"
        :to="link"
        class="mb-2"
      >
        {{ linkLabel }}
      </router-link>
      <a
        v-if="autocomplete"
        href="#"
        class="ml-auto"
        @click.prevent="$emit('select')"
      >
        {{ $t('select') }}
      </a>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DxFormGroup',
  props: {
    label: [Number, String],
    link: {
      type: [String, Boolean],
      default: false,
    },
    linkLabel: String,
    marginBottom: {
      type: Boolean,
      default: true,
    },
    autocomplete: Boolean,
  },
};
</script>
